import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledGreenCardRequest = styled.div`
    position: relative;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
    @media ${breakpoints.xs} {
        height: 95%;
    }
    .greenCardTitle {
        font-size: var(--size-16);
        color: var(--color-grey-800);
    }
    .vehicleCard {
        position: relative;
        padding: 10px 15px;
        margin-top: 15px;
        background: var(--color-white);
        border-radius: var(--radius-10);
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
        .vehicleInf {
            margin-bottom: 10px;
            font-size: var(--size-14);
            color: var(--color-grey-900);
        }
        .policyholderInf {
            font-size: var(--size-14);
            color: var(--color-grey-800);
        }
        .iconGoodsCategory {
            position: absolute;
            right: 0;
            bottom: -5px;
        }
    }
    .btnWrapper {
        position: absolute;
        bottom: 0;
        width: 100%;
    }
`;
